module.exports = __webpack_public_path__ + "static/commercial-demolition-single-c84304902b5ab5d064c1ecd4e34f2c00.jpg";